<template>
    <div class="row">
        <div class="col" v-if="isLoading">
            <card>
                 <span slot="header">
                  </span>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                 spin></font-awesome-icon></span></h1>
                <div slot="footer">
                </div>
            </card>
        </div>
        <InternalExtensionCard class="col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3" v-if="!isLoading"
                               :initialIVR="internal"
                               v-on:button-add="" v-on:button-remove=""></InternalExtensionCard>
    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import swal from 'sweetalert2';
    import InternalExtensionCard from "./InternalExtensionCard";

    export default {
        name: "InternalExtensionGrid",
        components: {
            InternalExtensionCard,
            swal,
        },
        computed: {
            ...mapFields(`sipdevice`, ['sipdevices']),
            ...mapFields(`ivr`, ['internal']),
        },
        data() {
            return {
                isLoading: false,
                inputVisible: false,
                showAddButtonModal: false,
            };
        },
        methods: {
            created() {
                this.loadInternal();
            },
            loadInternal() {
                this.isLoading = true;
                this.$store.dispatch('ivr/loadInternal').then(() => {
                    this.isLoading = false;
                })
            },
        },
        mounted() {
            if (this.$store.getters['sipdevice/needUpdate']) {
                this.$store.dispatch('sipdevice/loadSIPDevices');
            }
            this.loadInternal();
        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
